export default "__VITE_PUBLIC_ASSET__0d189104__"